import { createFileRoute } from '@tanstack/react-router';

import { WatchlistPage } from '@/features/watchlist/WatchlistPage';
import { isMarket, type Market } from '@/lib/market/types';

/**
 * `/:market/watchlist` —— 預設自選股清單的報價總覽（features/watchlist/WatchlistPage.tsx）。
 * `?as_of` 在 `__root.tsx` 宣告，這裡繼承：倒帶時看的是那一天的報價。
 */
export const Route = createFileRoute('/$market/watchlist')({
  component: WatchlistRoute,
});

function WatchlistRoute() {
  const { market: rawMarket } = Route.useParams();
  const market: Market = isMarket(rawMarket) ? rawMarket : 'tw';
  return <WatchlistPage market={market} />;
}
